import { FC, useEffect } from "react";
import { Controller } from "react-hook-form";
import { observer } from "mobx-react-lite";


import { ISelect, AutoComplete } from "../../ui-kit";
import { useHandleForm } from "../../hooks/useHandleForm";
import usersStore from "../../store/users";
import api from "./api";
import { Filter } from "../../store/core";
import { FilterCondition } from "../../constants/Enums";

const DEFAULT_VALUES = {
    organizationId: null,
    organizationName: null,
    userGroupId: null,
    status: null,
}

interface IUsersFilterProps {
    filter: Filter;
}

const UsersFilter: FC<IUsersFilterProps> = observer(({filter}) => {
    const { roles } = usersStore;

    const {
        watchAllField,
        control,
        getValues,
        setValue,
        formState,
    } = useHandleForm(
        null,
        DEFAULT_VALUES,
        null
    );

    const fields = [
        {
            component: ({field}) => <AutoComplete
                field={field}
                label="Организация"
                getData={api.getAllOrganizations}
                onChange={(newValue) => {if(!newValue) setValue("organizationId", null)}}
                onSelect={(newValue) => {setValue("organizationId", newValue?.id)}}
            />,
            name: "organizationName",
        },
        {
            component: ({field}) => <ISelect
                field={field}
                optionsArr={roles}
                placeholder="Роль"
            />,
            name: "userGroupId",
        },
        {
            component: ({field}) => <ISelect
                field={field}
                optionsArr={[{id: "active",name: "Активен"},{id: "locked", name: "Заблокирован"},{id: "deleted", name: "Удален"}]}
                placeholder="Статус"
            />,
            name: "status",
        },
    ];

    useEffect(()=>{
        applyFilter()
    }, [watchAllField.userGroupId, watchAllField.status, watchAllField.organizationId])

    const applyFilter = () => {
        const values = getValues();

        delete values.user;
        if(values.status === "active") {
            values["user.isDeleted"] = {
                value: false,
                conditionType: FilterCondition.Equal
            };
            values["user.isDisabled"] = {
                value: false,
                conditionType: FilterCondition.Equal
            };
            values["user.lockoutEnd"] = {
                value: null,
                conditionType: FilterCondition.Equal
            };
        }
        if(values.status === "deleted") {
            values["user.isDeleted"] = {
                value: true,
                conditionType: FilterCondition.Equal
            };
        }
        if(values.status === "locked") {
            values["user.isDisabled"] = {
                value: true,
                conditionType: FilterCondition.Equal
            };
        }
        delete values.status;
        filter.setFilterItemsWithoutFilter(values);
    }

  return (
    fields.map((filterField) => {
        return (
            <Controller
                control={control}
                name={filterField.name}
                render={filterField.component}
            />
        );
    })
  );
});

export default UsersFilter;